var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTopBarHome = function SvgTopBarHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m18.486 9.863-8.045-8.039a.623.623 0 0 0-.882 0l-8.045 8.04a1.251 1.251 0 0 0 .883 2.135h.847v5.735c0 .346.28.625.625.625H8.75v-4.375h2.188v4.375h5.193c.346 0 .625-.279.625-.625v-5.736h.848a1.251 1.251 0 0 0 .883-2.135"
  })));
};
export default SvgTopBarHome;